module.exports = __webpack_public_path__ + "static/media/editIcon.b8f11e22.svg";